import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const DeleteIcon = ({ color, ...otherProps }) => {
  return (
    <SvgIcon
      viewBox="0 0 16 20"
      sx={{ width: '16px', height: '20px', fill: 'none' }}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6C13.5523 6 14 6.44772 14 7V17C14 18.6569 12.6569 20 11 20H5C3.34315 20 2 18.6569 2 17V7C2 6.44772 2.44772 6 3 6H13ZM12 8H4V17C4 17.5523 4.44772 18 5 18H11C11.5523 18 12 17.5523 12 17V8ZM5 1C5 0.447715 5.44772 0 6 0H10C10.5523 0 11 0.447715 11 1V2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H5V1Z"
        fill={color || '#FF5757'}
      />
    </SvgIcon>
  );
};

export default DeleteIcon;
